import { useAlertContext } from '../context/AlertContext';

export const useAlert = () => {
  const context = useAlertContext();
  
  return {
    alerts: context.alerts,
    showAlert: context.showAlert,
    removeAlert: context.removeAlert
  };
};